import AbstractForecastColumnTemplate from "./AbstractForecastColumnTemplate.js";
import ReferenceForecastColumn from "../instance/ReferenceForecastColumn.js";

/**
 * `ReferenceForecastColumnTemplate` is the editable reference of the concrete
 * ReferenceForecastColumn, which specifies how to compute a previous period data
 * when interpreting a forecasting template.
 */
export default class ReferenceForecastColumnTemplate extends AbstractForecastColumnTemplate {
	accept(visitor) {
		return visitor.visitReferenceForecastColumnTemplate(this);
	}

	isReferenceForecastColumnTemplate() {
		return true;
	}

	_instanceClass() {
		return ReferenceForecastColumn;
	}

	static getType() {
		return "ReferenceForecastColumnTemplate";
	}
}
